import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgGarage(
	{
		color,
		width = 50,
		height = 50
	}: IconsModel
) {
	return (
		<svg width={width} height={height} viewBox="0 0 50 50">
			<path
				d="M39.048 25.265c3.226 0 5.85 2.747 5.85 6.122 0 3.376-2.624 6.122-5.85 6.122-2.18 0-4.083-1.254-5.09-3.109H12.982c-1.007 1.855-2.91 3.11-5.09 3.11-3.226 0-5.85-2.746-5.85-6.122s2.624-6.122 5.85-6.122c3.226 0 5.85 2.746 5.85 6.122 0 .535-.067 1.054-.19 1.55h19.837a6.382 6.382 0 01-.19-1.55c0-3.376 2.624-6.123 5.85-6.123zM7.89 26.73c-2.455 0-4.452 2.09-4.452 4.66 0 2.568 1.997 4.658 4.452 4.658s4.452-2.09 4.452-4.659-1.997-4.659-4.452-4.659zm31.157 0c-2.455 0-4.452 2.09-4.452 4.658 0 2.57 1.997 4.66 4.452 4.66s4.452-2.09 4.452-4.66c0-2.569-1.997-4.659-4.452-4.659zM28.418 12l6.11 9.071 9.328 1.43a6.835 6.835 0 014.458 2.698A8.665 8.665 0 0150 30.349v4.1h-3.75v-1.414h2.322v-2.687a7.274 7.274 0 00-1.414-4.32 5.39 5.39 0 00-3.52-2.13l-9.585-1.47h-15.68l-1.654-6.545 1.385-.343 1.383 5.475h13.287l-5.12-7.601H12.86a8.606 8.606 0 00-6.119 2.559c-1.367 1.395-2.156 3.165-2.264 5.042h11.418v1.414H3.752c-1.283 0-2.324 1.03-2.324 2.298v1.503H0v-1.503c0-1.807 1.311-3.317 3.041-3.645.094-2.272 1.03-4.415 2.674-6.093A10.046 10.046 0 0112.855 12h15.564z"
				fill={color}
				fillRule="evenodd"
			/>
		</svg>
	)
}

export default SvgGarage
